import { httpV1 as http } from '@/services/api';

/** Conquistas do vendedor (B2B-320). */

export async function recordEvent(achievementId, eventName, eventSource) {
  return http.post(`/backoffice/achievements/${achievementId}/events`, {
    event_name: eventName,
    event_source: eventSource || null,
  });
}
